import { render, staticRenderFns } from "./DropDownGeneric.vue?vue&type=template&id=2c3a24d5&scoped=true&"
import script from "./DropDownGeneric.vue?vue&type=script&lang=js&"
export * from "./DropDownGeneric.vue?vue&type=script&lang=js&"
import style0 from "./DropDownGeneric.vue?vue&type=style&index=0&id=2c3a24d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a24d5",
  null
  
)

export default component.exports